<ng-content select="app-panel-header"></ng-content>
<section [ngStyle]="{'padding': contentPadding}">
    <ng-content></ng-content>
</section>
<ng-content select="app-panel-footer"></ng-content>
